<template>
  <div class="el-popper searchable-dropdown" :style="{ minWidth: minWidth }">
    <div>
      <el-input v-model="query" placeholder="搜索">
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <el-scrollbar v-if="computedList.length != 0" tag="ul" ref="scrollbar" wrap-class="search-scroll_wrap">
      <!-- check(item.value) ? 'search-item selected' : 'search-item' -->
      <li v-for="(item, index) in computedList" :key='index' @click="onSelect(item.value)" class="search-item" :class="{'selected':check(item.value),'hq-item':HQ}">{{item.label}}</li>
    </el-scrollbar>
    <div style="font-size: 14px;color: #555; margin-top:10px" v-if="computedList.length === 0">
      没有搜索匹配项
    </div>
  </div>
</template>

<script type="text/babel">
import Popper from 'element-ui/lib/utils/vue-popper';
import ElScrollbar from 'element-ui/lib/scrollbar';
export default {
  mixins: [Popper],
  inject: ['select'],
  props: {
    placement: {
      default: 'bottom-start'
    },
    boundariesPadding: {
      default: 0
    },

    popperOptions: {
      default() {
        return {
          gpuAcceleration: false
        };
      }
    },

    visibleArrow: {
      default: true
    }
  },
  data() {
    return {
      minWidth: '',
      query: ''
    };
  },

  computed: {
    popperClass() {
      return this.$parent.popperClass;
    },
    computedList() {
      return this.select.options.filter(item => {
        return (
          item.label.toLowerCase().indexOf(this.query.toLowerCase()) !== -1
        );
      });
    }
  },

  watch: {
    '$parent.inputWidth'() {
      if (this.$parent.$el.getBoundingClientRect().width != 0) {
        this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
      }
    }
  },

  methods: {
    onSelect(value) {
      let options = this.select.value;
      if (
        (value == 'all' && options.indexOf('all') != -1) ||
        (value == 'none' && options.indexOf('none') != -1)
      ) {
        this.$emit('change', []);
        return;
      }
      if(value == 'all' && options.indexOf('all') == -1) {
        this.$emit('change', ['all']);
        return
      }
      if(value == 'none' && options.indexOf('none') == -1) {
        this.$emit('change', ['none']);
        return
      }
      if (options.indexOf('all') != -1 || options.indexOf('none') != -1) {
        this.$emit('change', [value]);
        return;
      }
      let index = options.indexOf(value);
      if (index == -1) {
        options.push(value);
      } else {
        options.splice(index, 1);
      }
      let hasNone =
        this.select.options.filter(item => {
          return item.value == 'none';
        }).length == 1;
      if (hasNone) {
        if (options.length == this.select.options.length - 2) {
          this.$emit('change', ['all']);
        } else {
          this.$emit('change', options);
        }
      } else {
        if (options.length == this.select.options.length - 1) {
          this.$emit('change', ['all']);
        } else {
          this.$emit('change', options);
        }
      }
    },
    onSelectAll() {
      this.$emit('change', []);
    },
    checkAll() {
      if (this.select.value.length === 0) {
        return true;
      }
    },
    check(val) {
      if (this.select.value.indexOf(val) != -1) {
        return true;
      }
    }
  },

  mounted() {
    this.referenceElm = this.$parent.$refs.reference.$el;
    this.$parent.popperElm = this.popperElm = this.$el;
    this.$on('updatePopper', () => {
      if (this.$parent.visible) this.updatePopper();
    });
    this.$on('destroyPopper', this.destroyPopper);
  }
};
</script>
<style lang="scss" scoped>
.searchable-dropdown {
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  margin: 5px 0;
  padding: 10px;
  z-index: 3000 !important;
}

.search-item {
  font-size: 14px;
  padding: 0 20px;
  padding-left: 4px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #5a5e66;
  height: 34px;
  line-height: 34px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}

.search-item.selected {
  color: var(--theme-color);
  &.hq-item{
    color: #337ab7;
  }
}
.search-item.selected:after {
  position: absolute;
  right: 10px;
  font-family: element-icons;
  content: '\E611';
  font-size: 12px;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
}

.search-item.hover,
.search-item:hover {
  background: #f5f7fa;
}
</style>




// WEBPACK FOOTER //
// src/components/search/searchTable/searchMenu.vue